/**
 * V1e · Types TypeScript pour la modération admin des CredentialVerification.
 *
 * Mirroir des types GraphQL générés côté @ekaa/graphql-types. Dupliqué ici
 * volontairement parce que apps/admin/ est une SPA Vite séparée qui n'a pas
 * (encore) le pipeline codegen pour les types GraphQL — pattern utilisé par
 * les autres ressources admin (cf. partners/partners.types.ts).
 */

export enum CredentialVerificationStatus {
  PENDING = 'PENDING',
  UNDER_REVIEW = 'UNDER_REVIEW',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum CredentialVerificationType {
  DIPLOMA = 'DIPLOMA',
  CERTIFICATION = 'CERTIFICATION',
  ORDER_NUMBER = 'ORDER_NUMBER',
  PROFESSIONAL_LICENSE = 'PROFESSIONAL_LICENSE',
}

export enum CredentialReviewDecision {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  UNDER_REVIEW = 'UNDER_REVIEW',
}

/**
 * `fieldSnapshot` est typé `any` côté API (Json scalar). Côté admin on
 * adoucit le typage pour permettre à la modale de l'afficher en JSON
 * formaté quoi qu'elle reçoive.
 */
export interface CredentialVerification {
  id: string;
  userId: string;
  digitalCardId: string;
  type: CredentialVerificationType;
  fieldRef: string;
  fieldSnapshot: Record<string, unknown> | unknown;
  documentUrl: string | null;
  documentMimeType: string | null;
  documentSize: number | null;
  submissionNote: string | null;
  status: CredentialVerificationStatus;
  reviewedByUserId: string | null;
  reviewedAt: string | null;
  reviewNote: string | null;
  rejectReason: string | null;
  submittedAt: string;
  updatedAt: string;
}

export interface CredentialVerificationQueueResponse {
  items: CredentialVerification[];
  total: number;
}

/**
 * V1e+ · Stats panel de la queue de modération.
 *
 * - countsByStatus : nombre global de demandes par status
 * - avgModerationTimeHours : temps moyen entre submit et review (fenêtre)
 * - topReviewers : top 5 admins par volume modéré (fenêtre)
 * - windowDays : fenêtre temporelle (default 30j)
 */
export interface CredentialReviewerStat {
  userId: string;
  reviewedCount: number;
}

export interface CredentialModerationStats {
  countPending: number;
  countUnderReview: number;
  countApproved: number;
  countRejected: number;
  avgModerationTimeHours: number | null;
  topReviewers: CredentialReviewerStat[];
  windowDays: number;
}
